'use client';

import { usePathname } from 'next/navigation';
import { useContext, useEffect, useState } from 'react';
import { getSearchUrl, SearchFilterContentTypes, SearchOption, SearchOrigins } from 'search-gateway-client';

import { StatsigExperimentContext } from '../context/NavSearchContext';
import { SearchBarVariant } from './NavSearchElements/searchUtils';
import ProminentSearch from './ProminentSearchLegacy';
import { getUserDataAction } from './getUserDataAction';

interface ProminentSearchContainerProps {
    imagesUrl: string;
    contentTypes: SearchOption[];
    contentType: SearchFilterContentTypes;
    setContentType: (newContentType: SearchFilterContentTypes) => void;
    showDropdown?: boolean;
    alignment?: 'left' | 'center';
    showContentToggles?: boolean;
}

const ProminentSearchContainer = ({
    imagesUrl,
    contentTypes,
    contentType,
    setContentType,
    showDropdown = true,
    alignment = 'left',
    showContentToggles,
}: ProminentSearchContainerProps) => {
    const pathname = usePathname();
    const context = useContext(StatsigExperimentContext);

    const [auth, setAuth] = useState<{
        hasAnySubscription?: boolean;
        isEnterprise?: boolean;
        permissions?: {
            pproPluginEnabled?: boolean;
        };
    }>({});
    const [showSuggestions, setShowSuggestions] = useState(false);
    const handleSubmit = (event: string, value: string, searchOrigin: SearchOrigins) => {
        const searchUrl = getSearchUrl({
            contentType: event as SearchFilterContentTypes,
            searchTerm: value,
            searchOrigin,
        });
        window.location.href = searchUrl;
    };
    useEffect(() => {
        getUserDataAction().then((data) => {
            if (data) {
                setAuth(data.auth);
            }
        });
    }, []);

    const { hasAnySubscription = false, isEnterprise = false, permissions: { pproPluginEnabled = false } = {} } = auth;

    return (
        <ProminentSearch
            contentType={contentType}
            onDropdownChange={(contentType) => {
                setContentType(contentType as SearchFilterContentTypes);
            }}
            onSubmit={handleSubmit}
            searchTerm={''}
            userHasAnySubscription={hasAnySubscription}
            isEnterpriseMember={isEnterprise}
            pproPluginEnabled={pproPluginEnabled}
            isSearchAppLoaded={() => false}
            imagesUrl={imagesUrl}
            prominentSearchOptions={contentTypes}
            contentTypeFromPrevious={contentType || SearchFilterContentTypes.All_videos_content_type}
            showDropDown={showDropdown}
            showContentToggles={showContentToggles || ['/', '/audio'].includes(pathname)}
            alignment={alignment}
            setShowSuggestions={setShowSuggestions}
            showSuggestions={showSuggestions}
            searchBarVariant={
                context?.isSearchHistoryEnabled
                    ? SearchBarVariant.ProminentSearchHistoryExperiment
                    : SearchBarVariant.ProminentLanding
            }
        />
    );
};

export default ProminentSearchContainer;
